<template>
  <div class="columns is-multiline">
    <!-- 반품 정보 입력 페이지
    반품 검사중 상태인 주문 상품만 표시됩니다. -->
    <div class="column is-full">
      <admin-form-item label="환불 상품">
        <table class="delivery-orderproduct-table">
          <thead>
          <tr>
            <th style="width:35%">주문 상품</th>
            <th style="width:15%">옵션 단가</th>
            <th style="width:10%">수량</th>
            <th style="width:15%">할인 금액</th>
            <th style="width:25%">주문 상태</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(op,idx) in order_product" :key="'op-'+idx">
            <td>
              <div class="flex align-center">
                <img :src="op.product.img" style="width:35px;height:35px;margin-right:6px" v-if="op.product.img">
                <div style="text-align: left">
                  <div v-if="op.order_product_option.length>0">
                    <div>{{ op.product.name }}</div>
                    <div style="color:#C1C1C1;font-size:14px"
                         v-for="(option, option_idx) in op.order_product_option"
                         :key="'option-'+option_idx">
                      <span v-if="option.option.option_type===0">기본옵션:</span>
                      <span v-if="option.option.option_type===1">추가옵션:</span>
                      {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                    </div>
                  </div>
                  <div v-else>
                    {{ op.product.name }} {{ op.quantity }}개
                  </div>
                </div>
              </div>

            </td>
            <td>{{ op.total_price | currency }}</td>
            <td>
              <input class="input product-short-input"
                     v-model="op.quantity"
                     @input="e => setQauntity(e, op)"
                     type="number">
            </td>
            <td>{{ op.discount_price | currency }}</td>
            <td>{{ op.status_kor }}</td>
          </tr>
          <tr style="background-color:#EBEAE4">
            <td colspan="4">총 결제 금액</td>
            <td>{{ calcTotalPrice | currency }}</td>
          </tr>
          </tbody>
        </table>
      </admin-form-item>
    </div>

    <div class="column is-full">
      <admin-form-item label="결제 취소/환불 금액">
        <table class="delivery-orderproduct-table">
          <thead>
          <tr>
            <th style="width:20%">항목</th>
            <th style="width:60%">내용</th>
            <th style="width:20%">환불 금액</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>배송비</td>
            <td style="text-align: left !important;">
              <div>배송비: {{ order.delivery_cost | currency }}</div>
              <div style="margin-top:8px">
                <lp-radio :val.sync="value.is_first_dp_refund"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'환불 안 함',value:false}, {label:'환불', value:true}]"></lp-radio>
              </div>
            </td>
            <td>
              <div v-if="value.is_first_dp_refund">{{ order.delivery_cost | currency }}</div>
              <div v-else>0원</div>
            </td>
          </tr>
          <tr>
            <td>결제 금액</td>
            <td style="text-align: left !important;">
              <div>총 결제 금액: {{ calcProductPrice | currency }}</div>
              <div style="margin-top:8px">
                <lp-radio :val.sync="value.refund_type"
                          value_name="value"
                          label_name="label"
                          :showInput="true"
                          :block="true"
                          @onEdit="res => inputRefundPrice(res)"
                          :data="[{label:'전액 환불', value:0},
                                  {label:'부분 환불', value:1, num: value.refund_part_price, unit:'원'}]"></lp-radio>
                <!--<div v-if="order.cancel_price>0">현재까지 부분 취소된 금액: {{ order.cancel_price }}</div>-->
              </div>
            </td>
            <td>{{ calcRefundPrice | currency }}</td>
          </tr>
          <tr>
            <td>적립금 사용</td>
            <td style="text-align: left !important;">
              <div>초기 사용 금액: {{ order.point | currency }}</div>
              <div class="flex-align">
                <lp-check-bool :checkedVal.sync="value.is_cancel_point"
                               label="적립금 적용 취소"></lp-check-bool>
                <div class="flex-align" style="margin-left:8px">
                  <input class="input full has-text-right"
                         style="width:150px"
                         v-model="value.point"
                         @input="e => setNumber(e, 'point')"
                         :disabled="!value.is_cancel_point"
                         :min="0"
                         type="number">
                  <span style="margin:auto 4px;font-size:0.9rem">원</span>
                </div>
              </div>
            </td>
            <td>-{{ value.point | currency }}</td>
          </tr>
          <tr>
            <td>쿠폰 할인</td>
            <td style="text-align: left !important;">
              <div>초기 사용 금액: {{ order.coupon_price | currency }}</div>
              <div class="flex-align">
                <lp-check-bool :checkedVal.sync="value.is_cancel_coupon"
                               label="쿠폰 적용 취소"></lp-check-bool>
                <div class="flex-align" style="margin-left:8px">
                  <input class="input full has-text-right"
                         style="width:150px"
                         v-model="value.coupon_price"
                         @input="e => setNumber(e, 'coupon_price')"
                         :disabled="!value.is_cancel_coupon"
                         :min="0"
                         type="number">
                  <span style="margin:auto 4px;font-size:0.9rem">원</span>
                </div>
              </div>
            </td>
            <td>-{{ value.coupon_price | currency }}</td>
          </tr>
          <tr style="background-color:#EBEAE4">
            <td colspan="2">환불 금액 합계</td>
            <td>{{ calcTotalRefundPrice | currency }}</td>
          </tr>
          </tbody>
        </table>
      </admin-form-item>
    </div>

    <div class="column is-full">
      <admin-form-item label="환불 방법">
        <div>
          <lp-radio :val.sync="value.refund_method"
                    value_name="value"
                    label_name="label"
                    :data="refundMethodArr"></lp-radio>
        </div>
        <div style="margin-top:6px">
          <span v-if="value.refund_method===0" class="flex">
            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>환불 계좌로 직접 송금하는 방식입니다.</span>
          <span v-else-if="value.refund_method===1" class="flex">
            <i class="material-icons" style="font-size:20px;margin-right:2px">info_outline</i>환불 방법을 저장한 뒤, '환불 관리'에서 환불 처리해 주시기 바랍니다.</span>
        </div>
        <div class="columns is-multiline" style="margin-top:0" v-if="value.refund_method===0">
          <div class="column is-3">
             <span class="select">
              <select v-model="value.refund_info.bank"
                      @change="e=> value.refund_info.bank = e.target.value">
                <option value="" disabled selected>환불 계좌 선택</option>
                <option v-for="(bank, idx) in bankArr" :key="`bank-${idx}`">{{ bank.label }}</option>
              </select>
            </span>
          </div>
          <div class="column is-6">
            <input class="input"
                   :value="value.refund_info.account_num"
                   @input="e=> value.refund_info.account_num = e.target.value"
                   placeholder="계좌번호"
                   type="text">
          </div>

          <div class="column is-3">
            <input class="input"
                   :value="value.refund_info.name"
                   @input="e=> value.refund_info.name = e.target.value"
                   placeholder="계좌주"
                   type="text">
          </div>
        </div>
      </admin-form-item>
    </div>

    <div class="column is-full">
      <div class="flex justify-center">
        <button class="button is-light" @click="$emit('close')">취소</button>
        <button class="button is-primary" style="margin-left:6px;" @click="saveData">환불 완료 처리</button>
      </div>
    </div>
  </div>
</template>

<script>
  import AdminFormItem from "../../../module/admin/AdminFormItem";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";

  export default {
    components: {
      LpCheckBool,
      LpRadio,
      AdminFormItem},
    name: "order-cancel-refund",
    props: {
      order: {
        type: Object,
        required: true
      },
    },
    data () {
      return {
        is_modify: false,
        value: {
          is_first_dp_refund: false, // 초기 배송비 환불 여부
          dp_type: 0, // 반품 배송비 종류 ( 0: 선불 1: 환불금액에서 차감 2: 착불 )
          substraction_price: 0, // 환불 금액에서 차감할 금액
          refund_type: 0, // 환불 종류(0: 전액, 1: 부분)
          refund_price: 0,  // 환불 금액
          refund_method: 0,  // 환불 방법(0: 현금, 1: 카드취소)
          // 환불 받을 계좌
          refund_info: {
            account_num: '',
            name: '',
            bank: ''
          },
          is_cancel_point: false,
          is_cancel_coupon: false,
          point: 0,
          coupon_price: 0,
          refund_all_price: 0,
          refund_part_price: 0
        },
        bankArr: [],
        // 선택된 주문 상품 (반품 검사중 상태)
        order_product: [],
      }
    },
    created () {
      this.getBankList();
      let arr = [];
      arr.push(this.order);
      let order_product = this.cloneItem(arr);
      this.order_product = order_product;

      if(this.value.refund_type===0) {
        this.value.refund_all_price = this.calcProductPrice;
        if (this.order.order.refund_info.account !== '') {
          this.value.refund_info.account_num = this.order.order.refund_info.account;
        }
        if (this.order.order.refund_info.bank !== '') {
          this.value.refund_info.bank = this.order.order.refund_info.bank;
        }
        if (this.order.order.refund_info.name !== '') {
          this.value.refund_info.name = this.order.order.refund_info.name;
        }
      }
    },
    watch: {
      // 환불 종류
      'value.refund_type'(n) {
        if(n===0) {
          this.value.refund_all_price = this.calcProductPrice;
          this.value.refund_part_price = 0;

          if (this.order.refund_info.account !== '') {
            this.value.refund_info.account_num = this.order.refund_info.account;
          }
          if (this.order.refund_info.bank !== '') {
            this.value.refund_info.bank = this.order.refund_info.bank;
          }
          if (this.order.refund_info.name !== '') {
            this.value.refund_info.name = this.order.refund_info.name;
          }
        }
      },
      // 반품 배송비 종류
      'value.dp_type'(n) {
        if(n!==1) this.value.substraction_price = 0;
      },
      // 포인트 차감 사용여부
      'value.is_cancel_point'(n) {
        if(!n) this.value.point = 0;
      },
      // 쿠폰 차감 사용여부
      'value.is_cancel_coupon'(n) {
        if(!n) this.value.coupon_price = 0;
      }
    },
    computed: {
      calcTotalPrice () {
        let price = 0;
        this.order_product.forEach(item => {
          price += item.total_price;
        })
        return price;
      },
      // 주문 상품 금액
      calcProductPrice () {
        let price = 0;
        this.order_product.forEach(item => {
          price += (item.product_price * item.quantity) - (item.discount_price * item.quantity);
        })
        return price;
      },
      // 환불 방법 목록
      refundMethodArr () {
        let arr = [{label:'현금 환불 (입금)',value:0}];
        // if(this.order.pay_type!==2) {
        //   arr.push({label:'카드 취소', value:1});
        // }
        return arr
      },
      // 환불 총 합계
      calcTotalRefundPrice () {
        // 환불 금액 - 차감할 금액
        let total = this.calcRefundPrice - this.value.substraction_price;
        if(this.value.is_first_dp_refund) total += this.order.delivery_cost;
        if(this.value.is_cancel_point) total -= this.value.point;
        if(this.value.is_cancel_coupon) total -= this.value.coupon_price;
        return total
      },
      // 환불 종류에 따른 환불 금액
      calcRefundPrice () {
        // 0: 전액 환불, 1: 부분 환불
        if(this.value.refund_type===0) {
          return this.value.refund_all_price;
        }
        else {
          return this.value.refund_part_price;
        }
      }
    },
    methods: {
      // clickTest() {
      //   let param = {
      //     refund_info: {
      //       account: 32440,
      //       bank: '우리은행',
      //       name: 'test'
      //     }
      //   } 
      //   this.$axios.post(`user/1/delivery/order/${this.order.order_id}/refund/account`, value).then(res => {
      //     if(res.status===200) {
      //       this.toast('저장되었습니다')
      //     }
      //   })
      // },
      setQauntity(e, op) {
        op.quantity = parseInt(e.target.value.substr(0, 2));
      },
      setNumber (e, depth) {
        let price = parseInt(e.target.value);
        if(price > this.order[depth]) {
          this.value[depth] = this.order[depth];
        }
        else {
          this.value[depth] = price;
        }


      },
      // 반품 배송비에서 차감 금액
      inputSubstractionPrice (res) {
        console.log(res)
        let price = 0;
        if (res.text === '' || res.text === 0) price = 0;
        else price = parseInt(res.text)
        // 환불 금액에서 차감
        if(res.value===1) {
          if(this.calcTotalRefundPrice>0) {
            this.value.substraction_price = price;
          }
        }
      },
      // 반품 배송비 금액
      inputRefundPrice (res) {
        console.log(res)
        let price = 0;
        if (res.text === '' || res.text === 0) price = 0;
        else price = parseInt(res.text)
        // 전액 환불
        if(res.value===0) {
          this.value.refund_all_price = this.calcProductPrice;
        }
        // 부분 환불
        else if(res.value===1) {
          if(price > this.calcProductPrice) {
            this.value.refund_part_price = this.calcProductPrice;
          }
          else this.value.refund_part_price = price;
        }
      },
      saveData () {
        let value = this.cloneItem(this.value);
        if(this.calcTotalRefundPrice<0) {
          this.toast('환불할 금액을 0원이상 설정하세요.');
          return
        }
        value.refund_price = this.calcTotalRefundPrice;
        if(value.refund_price>this.calcTotalPrice) {
          this.toast('환불할 금액을 총 결제 금액보다 낮게 입력하세요.');
          return
        }
        if (value.refund_type === 0) {
          if (this.value.refund_info.bank === '') {
            this.toast('환불 계좌 은행을 선택해주세요.');
            return;
          }
          if (this.value.refund_info.account_num === '') {
            this.toast('환불 계좌번호를 입력해주세요.');
            return;
          }
          if (this.value.refund_info.name === '') {
            this.toast('계좌주명을 입력해주세요.');
            return;
          }
        }
        let id_list = [];
        this.order_product.forEach(item => {
          id_list.push(item.id)
        })
        value.order_product = id_list;
        if(this.is_modify) {
          this.$axios.patch(this.getUrl(`delivery/order/${this.order.order_id}/refund/${this.order.id}`), value).then(res => {
            if(res.status===200) {
              this.toast('저장되었습니다')
              this.$emit('confirm')
            }
          })
        }
        else {
          this.$axios.post(this.getUrl(`delivery/order/${this.order.order_id}/refund`), value).then(res => {
            if(res.status===200) {
              this.toast('저장되었습니다')
              this.$emit('confirm')
            }
          })
        }
      },
      getBankList() {
        this.$axios.get('public/banks').then(res=>{
          this.bankArr = res.data;
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    border-bottom-width thin !important
    padding 6px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
    background-color #eee
</style>
